<page-headline
    [linkTitle]="'Performance Home'"
    [module]="'performance'"
    [moduleIcon]="'fa-heartbeat'"
    [moduleLink]="'performance'"
    [pageTitle]="'Reports'"
>
</page-headline>

<p>
    This page is a placeholder.
</p>
